export const packageFreeShippingDecorator = (groupData, hasFreeShippingPromo) => {
    if (groupData.products) {
        groupData.products.forEach((product) => {
            // define if free shipping promo applicable for the package
            const packagePrice = Number.parseFloat(product.retailPrice)
            product.freeShipping = hasFreeShippingPromo && !Number.isNaN(packagePrice) && packagePrice > 200
        })
    }
}